import React from "react";
import { RichUtils } from "draft-js";

interface Props {
  onChange: (state: Draft.EditorState) => void;
  editorState: Draft.EditorState;
  style: string;
  label: string;
  title: string;
  className: string;
}

export default function InlineStyleButton(props: Props) {
  const { onChange, editorState, style, label, title, className } = props;

  const preventClick = (evt: React.MouseEvent) => evt.preventDefault();

  const handleClick = (evt: React.MouseEvent) => {
    evt.preventDefault();
    onChange(RichUtils.toggleInlineStyle(editorState, style));
  };

  const classNames = [className];
  if (editorState.getCurrentInlineStyle().has(style)) {
    classNames.push("active");
  }

  return (
    <button
      className={classNames.join(" ")}
      title={title}
      onMouseDown={handleClick}
      onClick={preventClick}>
      {label}
    </button>
  );
}
